// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import TopBar from "./components/layout/TopBar";
import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";
import CategoryShell from "./components/layout/CategoryShell";
import AdminProducts from "./admin/AdminProducts";
import AdminOrders from "./admin/AdminOrders";
import AdminDashboard from "./admin/AdminDashboard";

import HomePage from "./pages/HomePage";
import ProductDetailPage from "./pages/ProductDetailPage";
import CategoryPage from "./pages/CategoryPage";
import CartPage from "./pages/CartPage";
import LoginPage from "./pages/LoginPage";

import { AuthProvider } from "./context/AuthContext";
import RequireAuth from "./components/auth/RequireAuth";

function PaygateReturnPage() {
  return (
    <div className="py-5 bg-white">
      <div className="container text-center">
        <h4 className="mb-3">Merci pour votre paiement</h4>
        <p className="text-muted">
          Si le paiement a été validé, vous recevrez une confirmation.
        </p>
        <a href="/" className="btn btn-primary btn-sm mt-2">
          Retour à la boutique
        </a>
      </div>
    </div>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <div className="app-root">
          {/* Panneau central */}
          <CategoryShell>
            <TopBar />
            <Header />

            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/produit/:slug" element={<ProductDetailPage />} />
              <Route path="/categorie/:slug" element={<CategoryPage />} />
              <Route path="/panier" element={<CartPage />} />
              <Route path="/login" element={<LoginPage />} />

              {/* 🔐 Admin protégé */}
              <Route
                path="/admin/products"
                element={
                  <RequireAuth>
                    <AdminProducts />
                  </RequireAuth>
                }
              />
                <Route
                path="/admin/orders"
                element={
                  <RequireAuth>
                    <AdminOrders />
                  </RequireAuth>
                }
              />
                <Route
                path="/admin/dashboard"
                element={
                  <RequireAuth>
                    <AdminDashboard />
                  </RequireAuth>
                }
              />
              <Route path="/paygate-retour" element={<PaygateReturnPage />} />
            </Routes>

            <Footer />
          </CategoryShell>
        </div>
      </AuthProvider>
    </Router>
  );
}

export default App;
